/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-underscore-dangle */
import { Middleware, EntityState } from '@reduxjs/toolkit';

import { autoListItemsSlice, TItemOrUndefined } from './slice';
import { findBiggestBet } from '../../services';

type TMiddlewareAction = ReturnType<typeof autoListItemsSlice.actions.updateItem> & { __fromMiddleware?: boolean };

const updateHasBiggestBet = (itemsList: EntityState<TItemOrUndefined>, dispatch: any) => {
    const items = Object.values(itemsList.entities);
    const maxBet = findBiggestBet(items);

    items.forEach((item) => {
        if(item) {
            if(item.bet === maxBet) {
                dispatch({
                    ...autoListItemsSlice.actions.updateItem({
                        nm           : item.nm,
                        hasBiggestBet: true
                    }),
                    __fromMiddleware: true
                } as TMiddlewareAction);
            } else {
                dispatch({
                    ...autoListItemsSlice.actions.updateItem({
                        nm           : item.nm,
                        hasBiggestBet: false
                    }),
                    __fromMiddleware: true
                } as TMiddlewareAction);
            }
        }
    });
};

export const hasBiggestBetMiddleware: Middleware = (storeAPI) => (next) => (action) => {
    if((action as TMiddlewareAction).__fromMiddleware) {
        return next(action);
    }

    const result = next(action);

    if(autoListItemsSlice.actions.setAllItems.match(action)
        || autoListItemsSlice.actions.itemsToRemoveReset.match(action)
        || autoListItemsSlice.actions.addItems.match(action)
        || autoListItemsSlice.actions.clearRemovesItems.match(action)
        || autoListItemsSlice.actions.updateItem.match(action)
        || autoListItemsSlice.actions.updateItems.match(action)) {
        const state = storeAPI.getState();
        const { itemsList } = state[autoListItemsSlice.name];

        updateHasBiggestBet(itemsList, storeAPI.dispatch);
    }

    return result;
};
